class Form
{
    /**
     * Initialise Form functionality.
     *
     * @return {void}
     */
    static init() {
        Form.initTinyMce()
    }

    /**
     * Initialise the TinyMCE editor.
     *
     * @return {void}
     */
    static initTinyMce() {
        tinymce.init({
            relative_urls: false,
            remove_script_host: false,
            selector: "[data-tinymce]",
            plugins: 'image link',
            toolbar: 'undo redo | styleselect | bold italic | alignleft '
                + 'aligncenter alignright alignjustify | outdent indent | link image',
            content_css: "/css/core.min.css",
            content_style: "@import url('https://use.typekit.net/cqs3sxz.css');"
        })
    }
}

export default Form
